export default String.raw`
<dialog class="dialog wishlist-popup add-wishlist-popup-js middle">
    <div class="dialog__header">
        <h2 class="dialog__header-title">{{translations.AddToWishList}}</h2>
        <form method="dialog">
            <button class="dialog__close close-js" aria-label="{{ translations.Close }}">
                <svg aria-hidden="true" height="24" width="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                </svg>
            </button>
        </form>
    </div>
    <div class="dialog__content">
        {% if config.B2B -%}
            <!-- Many wishlists -->
            {% assign wishlists = customer-profile.WishLists -%}
            <div class="wishlist-popup__section">
                <h4 class="dialog__content-subtitle">{{translations.ChooseWishList}}</h4>
                <button class="pure-button add-new-wishlist-js">
                    {{translations.CreateWishList}}
                    <svg height="20" width="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#plus-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            </div>
            {% assign wishlistSize = wishlists | Size -%}
            <ul class="wishlist-popup__list">
                <li class="wishlist-popup__list-item hidden-js add-new-wishlist-target-js">
                    <input aria-label="{{ translations.NewWishList }}" tabindex="0" class="wishlist-popup__radio" id="wishlistId_new" type="radio" name="wishlistId" value="-1">
                    <label for="wishlistName_new" tabindex="-1" class="form__input-wrapper">
                        <input id="wishlistName_new" class="form__input-value input-value-js" name="wishlistName" type="text" required maxlength="500" placeholder="* {{ translations.NewWishList }}">     
                        <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{translations.FieldRequired}}</div>
                    </label>
                </li>
                {% for wishlist in wishlists -%}
                    <li class="wishlist-popup__list-item">
                        <input id="wishlist-id-{{forloop.index}}" aria-label="{{wishlist.Data.Name}}" tabindex="0" class="wishlist-popup__radio" type="radio" name="wishlistId" value="{{wishlist.Data.Id}}" {% if forloop.first %}checked{% endif %} >
                        <label tabindex="-1" role="radio" {% if forloop.first %} aria-checked="true" {% else -%} aria-checked="false" {% endif -%} for="wishlist-id-{{forloop.index}}" class="wishlist-popup__label">{{wishlist.Data.Name}}</label>
                    </li>
                {% endfor -%}
            </ul>
        {% endif -%}
    </div>
    <div class="dialog__actions">
        <form method="dialog">
            <button class="pure-button close-js">{{translations.Cancel}}</button>
        </form>
        <form method="dialog">
            <button class="primary-action-button add-to-wishlist-js close-js" {%if wishlistSize <= 0 %} disabled {% endif -%}>{{translations.Add}}</button>
        </form>
    </div>
</dialog>
`